/**
 * 公開ノートの 2 軸契約。正本: functions/src/publicPages/pagePublishing.ts
 *
 * 1. 知識軸「AIの回答に使う」= `status === 'public'`
 * 2. ページ軸「Webページとして公開する」= `webPageEnabled`（未設定なら `published === true` にフォールバック）
 *
 * ページ軸 ON は知識軸 ON を含意する。実際に配信できるかはワークスペースの
 * `settings/htmlPublish.enabled`（正本: src/utils/htmlPublish.ts）との AND。
 */

export const WEB_PAGE_ENABLED_FIELD = 'webPageEnabled';

export type PagePublishingData = {
  status?: unknown;
  published?: unknown;
  webPageEnabled?: unknown;
};

/** ページ軸の表示状態。 */
export type WebPageState =
  /** Webページを出さない */
  | 'off'
  /** 出す意図はあるが HTML 未生成 */
  | 'pending'
  /** URL で読める */
  | 'live'
  /** 出す意図はあるがワークスペース側のマスタースイッチ等で止まっている */
  | 'blocked';

/** 知識軸: 公開RAGの回答候補にするか。 */
export function isRagAnswerEnabledFromPage(
  data: PagePublishingData | null | undefined
): boolean {
  return data?.status === 'public';
}

/** ページ軸の意図。未設定は `published` にフォールバックする（既存WS互換）。 */
export function isWebPageIntendedFromPage(
  data: PagePublishingData | null | undefined
): boolean {
  if (typeof data?.webPageEnabled === 'boolean') {
    return data.webPageEnabled;
  }
  return data?.published === true;
}

/** HTML が生成済みか。 */
export function isWebPageGeneratedFromPage(
  data: PagePublishingData | null | undefined
): boolean {
  return isRagAnswerEnabledFromPage(data) && data?.published === true;
}

export function getWebPageState(
  data: PagePublishingData | null | undefined,
  htmlPagesEnabled: boolean
): WebPageState {
  if (!isWebPageIntendedFromPage(data)) return 'off';
  if (htmlPagesEnabled !== true) return 'blocked';
  if (!isRagAnswerEnabledFromPage(data)) return 'blocked';
  return data?.published === true ? 'live' : 'pending';
}
